import axios, { AxiosResponse } from 'axios';

// Data Response example:
// [
//   {
//     "id": 0,
//     "name": "string",
//     "descriptions": "string",
//     "order": 0,
//     "created_at": "2026-03-20T17:10:23.484Z",
//     "updated_at": "2026-03-20T17:10:23.484Z",
//     "deleted_at": "2026-03-20T17:10:23.484Z"
//   }
// ]
export const getUserGroups = async (): Promise<AxiosResponse<any>> => {
  return axios.get('/user-groups/');
};

export const createUserGroup = async (data: {
  name: string;
  descriptions: string;
  order: number;
}): Promise<AxiosResponse<any>> => {
  return axios.post('/user-groups/', data);
};

export const updateUserGroup = async (
  id: number,
  data: {
    name: string;
    descriptions: string;
    order: number;
  }
): Promise<AxiosResponse<any>> => {
  return axios.put(`/user-groups/${id}/`, data);
};

export const deleteUserGroup = async (
  id: number
): Promise<AxiosResponse<any>> => {
  return axios.delete(`/user-groups/${id}/`);
};
